import { schema } from 'normalizr'

import customer from './customer'
import user from './user'

export const messageSchema = new schema.Entity('messages', {
  user,
  customer,
})
export default messageSchema

export const messagesSchema = new schema.Array(messageSchema)
